import graphql from '@/graphql';
import graphqlHelper from '@/services/graphqlHelper';

const getDiets = () =>
  graphqlHelper({
    query: graphql.diet.queries.get,
    variables: {},
  });

export {
  // eslint-disable-next-line import/prefer-default-export
  getDiets,
};



// WEBPACK FOOTER //
// ./src/services/diet.js